@import 'src/styles/variabels';
@import 'src/styles/mobile';

// N2 (T5): renders below md only. One icon size (it was 72 px on the lists,
// 40 px under the patient card's meetings, the light grid's own glyph at
// 72 px), the label at the body size in the muted colour, centred.
.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $mobile-space-s;
  padding: $mobile-space-l 0;
  text-align: center;
  color: $color-secondary;
}
// doubled: the grids' wrappers size any icon inside them
.icon.icon {
  font-size: $mobile-empty-icon;
}
.text.text {
  font-size: $mobile-font-value;
  font-weight: normal;
  line-height: 1.5;
  text-transform: none;
  color: $mobile-text-secondary;
}
